import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Tetap pakai REACT_APP_
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
